import React from 'react'
import JobByLocation from '@freec/optimal-page/pages/job-by-location/job-by-location'
import LocationsFixture from '@freec/optimal-pagestatic-data/LocationsFixture'
import dynamic from 'next/dynamic'
const NotificationWrapper = dynamic(() => import('../modules/notifications/components/Notification/index'))
const NotificationBell = dynamic(() => import('../modules/notifications/components/NotificationBell/NotificationBell'))
const ChatCtxHeader = dynamic(() => import('../modules/chat/components/ChatCtxHeader/ChatCtxHeader'))
const EnrichModal = dynamic(() => import('../modules/enrich/index'))
const NotificationComponents = { NotificationBell, NotificationWrapper, EnrichModal, ChatCtxHeader }

export const getStaticProps = () => {
  return {
    props: {
      locations: LocationsFixture.data
        .map((loc) => ({
          id: loc.attributes.id,
          name: loc.attributes.state,
          name_vn: loc.attributes.state_vn
        }))
        .sort((a, b) => a?.name?.localeCompare(b?.name))
    }
  }
}
const JobByLocationPage = (props) => <JobByLocation {...props} NotificationComponents={NotificationComponents} />
export default JobByLocationPage
